import reqsTypes from "./reqs.types";

export const setReqsTab = (n) => ({
  type: reqsTypes.SET_REQS_TAB,
  payload: n,
});
export const setMyReqsPage = (n) => ({
  type: reqsTypes.SET_MYREQS_PAGE,
  payload: n,
});
export const setAllReqsPage = (n) => ({
  type: reqsTypes.SET_ALLREQS_PAGE,
  payload: n,
});

export const fetchMyReqsStart = () => ({
  type: reqsTypes.FETCH_MYREQS_START,
});

export const fetchMyReqsSuccess = (reqs) => ({
  type: reqsTypes.FETCH_MYREQS_SUCCESS,
  payload: reqs,
});

export const fetchAllReqsStart = () => ({
  type: reqsTypes.FETCH_ALLREQS_START,
});

export const fetchAllReqsSuccess = (reqs) => ({
  type: reqsTypes.FETCH_ALLREQS_SUCCESS,
  payload: reqs,
});

// async
let myLoadsCounter = 0;
export const fetchMyReqsAsync = (socket) => (dispatch, getState) => {
  const page = getState().reqs.myReqsPage;

  if (getState().reqs.myReqs.length % 30 !== 0) {
    const body = document.querySelector("body");
    console.log(body);
    return;
  }

  dispatch(fetchMyReqsStart());
  socket.emit("get_my_loads", { page });

  if (myLoadsCounter++ !== 0) return;
  socket.on("response_my_loads", (data) => {
    // console.log(data);
    dispatch(fetchMyReqsSuccess(data));
  });
};

let allLoadsCounter = 0;
export const fetchAllReqsAsync = (socket) => (dispatch, getState) => {
  const page = getState().reqs.allReqsPage;

  dispatch(fetchAllReqsStart());

  const arr = { page };
  socket.emit("get_loads", arr);

  if (allLoadsCounter++ !== 0) return;
  socket.on("response_loads", async (data) => {
    if (!getState().reqs.allReqs_isLoading) return;
    // console.log("dataaaa", data);
    // if (data.length > 1) {
    // alert("1");
    dispatch(fetchAllReqsSuccess(data));
    // }
  });
};
